import type { ComponentProps, ReactNode } from 'react';

import css from './styles.module.css';

type GroupHeaderEventHandlers = {
	[K in keyof ComponentProps<'div'> as K extends `on${string}`
		? K
		: never]?: ComponentProps<'div'>[K];
};

interface GroupHeaderDataAttributes {
	[key: `data-${string}`]: string | number | boolean | undefined;
}

interface GroupHeaderProperties
	extends GroupHeaderEventHandlers, GroupHeaderDataAttributes {
	label: string;
}

export function GroupHeader({
	label,

	...props
}: GroupHeaderProperties): ReactNode {
	return (
		<div {...props} className={css.header}>
			{label}
		</div>
	);
}
